module.exports = __webpack_public_path__ + "img/enterprise-main10.13530844.png";